<template>
  <CmsButtonBase
    v-if="displayCTA"
    :class="classes"
    :rel="ctaLink?.link?.rel"
    size="medium"
    :target="ctaLink?.link?.target"
    :to="ctaLink?.link?.href"
    :variant
    :width
    @click="sendTrackingData"
  >
    {{ ctaLink?.label }}
  </CmsButtonBase>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { CTALink } from '@backmarket/http-api/src/api-specs-content/models/cta-link'
import type { Tracking } from '@backmarket/http-api/src/api-specs-content/models/tracking'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import type { Maybe } from '@backmarket/utils/types/Maybe'
import type { Variants } from '@ds/components/Button/Button.constant'

import {
  getCTAClassesByHiddenDeviceType,
  isHiddenOnAllDevices,
} from '../BlockRenderer/devices'
import CmsButtonBase from '../CmsButtonBase/CmsButtonBase.vue'

const {
  ctaLink = undefined,
  tracking = undefined,
  width = 'adaptive',
  variant = 'primary',
} = defineProps<{
  ctaLink?: Maybe<CTALink>
  tracking?: Tracking
  width?: 'fixed' | 'adaptive' | 'full-width'
  variant?: Variants
}>()

const { trackClick } = useTracking()

const displayCTA = computed(() => {
  if (isEmpty(ctaLink)) return false

  return !isHiddenOnAllDevices({ devices: ctaLink?.hiddenDevices })
})

const classes = computed(() => {
  return getCTAClassesByHiddenDeviceType({
    hiddenDevices: ctaLink?.hiddenDevices,
  })
})

function sendTrackingData() {
  if (isEmpty(tracking)) return

  trackClick(tracking)
}
</script>
